<template>
  <div>
    <!-- Title -->
    <h6 v-if="data?.titulli" v-html="data?.titulli"></h6>
    <!-- 1) Plain text (e.g. address) -->
    <p v-if="data?.tekst1 && !data?.tekst2 && !data?.link">
      <font-awesome-icon v-if="data?.ikona1" :icon="['fa', data?.ikona1]" />&nbsp;
      <span v-html="data?.tekst1"></span>
    </p>
    <!-- 2) Contact phones -->
    <p v-if="data?.ikona2 === 'phone-volume' && (data?.tekst1 || data?.tekst2 || data?.tekst3)">
        <font-awesome-icon icon="phone-volume" v-if="data.tekst1" />&nbsp;
        <a v-if="data.tekst1" :href="`tel:${data?.tekst1}`">{{ data?.tekst1 }}</a><br/>
        
        <font-awesome-icon icon="phone-volume" v-if="data.tekst2" />&nbsp;
        <a v-if="data?.tekst2" :href="`tel:${data?.tekst2}`">{{ data?.tekst2 }}</a><br/>

        <font-awesome-icon icon="phone-volume" v-if="data?.tekst3" />&nbsp;
        <a v-if="data.tekst3" :href="`tel:${data?.tekst3}`">
            {{ data?.tekst3_title }}{{ data?.tekst3 }}
        </a>
    </p>
    <!-- 3) Emails -->
    <p v-else-if="data?.tekst1 && data?.tekst2 && data?.ikona1 === 'envelope' && data?.ikona2 === 'envelope'">
      <font-awesome-icon icon="envelope" />&nbsp;
      <a :href="`mailto:${data?.tekst1}`">{{ data?.tekst1 }}</a><br/>
      <font-awesome-icon icon="envelope" />&nbsp;
      <a :href="`mailto:${data?.tekst2}`">{{ data?.tekst2 }}</a>
    </p>
    <!-- 4) External link (magazine, social media, etc) -->
    <p v-else-if="data?.link">
      <font-awesome-icon v-if="data?.ikona_read" :icon="['fa', data?.ikona_read]" />
      <font-awesome-icon v-if="data?.ikona1" :icon="['fab', data?.ikona1]" />&nbsp;
       <a v-if="data?.read" :href="data?.link" target="_blank" rel="noopener noreferrer">
        {{data?.read}}
      </a>
       <a v-else :href="data?.link" target="_blank" rel="noopener noreferrer">
        {{data?.read1}}
      </a>
      <br>
      <font-awesome-icon v-if="data?.ikona2" :icon="['fab', data?.ikona2]" />&nbsp;
      <a :href="data?.link2" target="_blank" rel="noopener noreferrer">
        {{data?.read2}}
      </a>
    </p>
  </div>
</template>
<script>
export default {
    props: ['data']
};
</script>
<style scoped>
    h6 {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        color: #D0D5DD;
    }

    p {
        font-size: 15px;
        font-weight: 600;
        line-height: 23px;
        color: #EAECF0;
    }

    a {
        text-decoration: none;
        color: white;
    }
</style>